import { BASE_URL } from "../constants";
import { GuestServingEntity } from "../entities/GuestServingEntity";
import FetchUtils from "../utils/fetch";

class GuestServingsService {
    static async GetAllGuestServings(): Promise<GuestServingEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/guests/serving`);
        if (resp.status != 200) { throw resp.message }

        const data: GuestServingEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new GuestServingEntity({
                id: resp.data[i].ID,
                tanggal: resp.data[i].DatetimeIn,
                shift: resp.data[i].Shift,
                vendor: resp.data[i].Vendor,
                lokasi: resp.data[i].Lokasi,
                customer_name: resp.data[i].CustomerName,
                id_customer: resp.data[i].IDCustomer,
                payment: resp.data[i].PaymentType,
                type: resp.data[i].ServingType
            }))
        }

        return data;
    }

    static async GetReportGuestServings(start_date: string, end_date: string): Promise<GuestServingEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/guests/serving?start_date=${start_date}&end_date=${end_date}`);
        if (resp.status != 200) { throw resp.message }

        const data: GuestServingEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new GuestServingEntity({
                id: resp.data[i].ID,
                tanggal: resp.data[i].DatetimeIn,
                shift: resp.data[i].Shift,
                vendor: resp.data[i].Vendor,
                lokasi: resp.data[i].Lokasi,
                customer_name: resp.data[i].CustomerName,
                id_customer: resp.data[i].IDCustomer,
                payment: resp.data[i].PaymentType,
                type: resp.data[i].ServingType
            }))
        }

        return data;
    }

    static async AddGuestServings(data: {
        id_vendor_porsi: number,
        customer_name: string,
        id_customer: string,
        serving_type: 'REGULAR' | 'VEGETARIAN',
        payment_type: 'QRIS' | 'CASH',
    }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/guests/serving/serve`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateGuestServings(data: GuestServingEntity, fields: {
        customer_name?: string,
        id_customer?: string,
        payment_type?: 'QRIS' | 'CASH',
        serving_type?: 'REGULAR' | 'VEGETARIAN',
    }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/guests/serving/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteGuestServings(data: GuestServingEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/guests/serving/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { GuestServingsService };